import { useMemo } from "react";
import { isQdxTransactionType, validateSpecificFields } from "../utils";
import { validateSingleField835Lte } from "../schemas/validationSchema835Lte";
import { validateSingleFieldCorres } from "../schemas/validationSchemaCorres";
import { validateFieldPatientPay } from "../schemas/validationSchemaPP";

// Transaction type to validator mapping for better maintainability
const TRANSACTION_VALIDATORS = {
  PAYMENT835_LITE: validateSingleField835Lte,
  CORRESPONDENCE: validateSingleFieldCorres,
  PATIENT_PAY: validateFieldPatientPay,
};

export const useFieldValidator = (
  getValues,
  setError,
  clearErrors,
  contextValues
) => {
  return useMemo(() => {
    return (fieldNames) => {
      const transactionType = getValues('transaction_type');
      
      // Handle QDX transaction types
      if (isQdxTransactionType(transactionType)) {
        return validateSpecificFields(
          fieldNames,
          getValues(),
          setError,
          clearErrors,
          contextValues
        );
      }

      // Handle other transaction types using the mapping
      const validator = TRANSACTION_VALIDATORS[transactionType];
      if (validator) {
        return validator(
          fieldNames,
          getValues(),
          setError,
          clearErrors,
          contextValues
        );
      }

      // Return no-op function for unknown transaction types
      return () => {};
    };
  }, [getValues, setError, clearErrors, contextValues]);
};